export const getTotalPrice = (type: string, booking: any) => {
    let price = 0

    if (type === 'HolidayStay') {
        price += booking.departure?.price ?? 0

        booking.options.map((option: any) => {            
            price += option.price
        })
    }

    if (type === 'Bafad') {
        price += booking.accomodationOption.price

        booking.options.map((option: any) => {            
            price += option.price
        })
    }

    return price
}